/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless>): BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless {
        let obj = Object.assign(new BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless(), model);
        BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless>): BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless {
        if (!model) return null;
        return BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless.newInstance(<BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless) {
        if (!obj) return;

        models.BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID for the resource
     */
    service_account_id: string;

    /**
     * Cloud resource ID
     */
    resource_id: string;

    /**
     * Metric name being synced
     */
    metric_name: string;

    /**
     * ObjectId of the cloudops_event_logger alert document
     */
    alert_id: string;

}
